import { useSimProducts } from '../../hooks/useSimProducts';
import {
  enrichWithSessionListDetailsMapper,
  useSessionsListDetails,
} from 'src/simInventory/hooks/useSessionListDetails';
import { simProductsQueries } from '../queries/simProductsQueries';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';
import { useExtendsSimProductsWithActionsAvailability } from 'products/sim/Actions/hooks/useExtendsSimProductsWithActionsAvailability.ts';

export const useSimProductInventory = () => {
  const {
    simProducts,
    isRefetching,
    pagination: { totalNumberOfItems },
  } = useSimProducts();

  const imsis = simProducts?.items.filter((sim) => sim.imsi).map((sim) => sim.imsi as string);

  const { data: sessionsListDetails } = useSessionsListDetails({
    imsis,
    queryKey: simProductsQueries.sessionListDetails(imsis),
  });

  const isRadiusInterimsFilteringEnabled = useHasFeatureFlag('RadiusInterimsFiltering');
  const mappedSimProductItems = simProducts?.items.map((item) =>
    isRadiusInterimsFilteringEnabled
      ? enrichWithSessionListDetailsMapper(item, sessionsListDetails)
      : item,
  );

  const extendedSimProducts = useExtendsSimProductsWithActionsAvailability(mappedSimProductItems);

  return {
    inventory: {
      simProducts: {
        ...simProducts,
        items: extendedSimProducts,
      },
      totalNumberOfItems,
    },
    isRefetching,
  };
};
